import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UiService } from 'src/app/services/ui.service';
import { IconComponent } from '../icon/icon.component';
import { LabelTierDialogComponent } from '../label-marker/label-tier.dialog.component';

@Component({
    selector: 'multi-timeline-column',
    template: `
<div class="program_column" [ngClass]="{hidden_border: collapseObject[collapseStateId] === 'collapse' }">
  <div class="session_header mobile" (click)="toggleCollapse()" [ngClass]="{collapse: collapseObject[collapseStateId] === 'collapse' }">
    <icon class="arrow" [matIcon]="collapseObject[collapseStateId] === 'collapse' ? 'arrow_right' : 'arrow_drop_down'"></icon>
    <div class="title2">{{ title || 'Unnamed '+ uiService.programTerm.btn +'...' }}</div>
  </div>
  <div class="session_content" [ngClass]="{collapsed: collapseObject[collapseStateId] === 'collapse',  hide_details: !detailedMode}">
    <div class="program_info" [ngClass]="{ link: !standalone }" (click)="standalone ? null : openProgram.emit()">
      <div class="title2 desktop">{{ title || 'Unnamed '+ uiService.programTerm.btn +'...' }}</div>
      <div class="location" *ngIf="location">{{ location }}</div>
      <div class="location" *ngIf="address || venue"><b>{{ venue + (venue && address ? ', ' : '')}}</b>{{ address || '' }}</div>
      <div class="labels" *ngIf="programLabels && programLabels.length">
        <label-tier [labels]="programLabels" [template]="labelTemplate"></label-tier>
      </div>
    </div>
    <ng-content></ng-content>
  </div>
</div> <!-- end of program column-->

  `,
    styleUrls: ['multi-timeline-column.scss'],
    standalone: true,
    imports: [CommonModule, IconComponent, LabelTierDialogComponent],
})
export class MultiTimelineColumnComponent {
  @Input() title = ''
  @Input() location = ''
  @Input() venue? = ''
  @Input() address? = ''
  @Input() programLabels
  @Input() labelTemplate
  @Input() detailedMode
  @Input() standalone = false
  @Input() collapseObject: { [key: string]: 'collapse' | 'expand' } = {}
  @Input() collapseStateId = "anyId"
  @Output() openProgram: EventEmitter<void> = new EventEmitter()

  constructor(public uiService:UiService){}

  toggleCollapse() {
    const state = this.collapseObject[this.collapseStateId]
    this.collapseObject[this.collapseStateId] = state === 'collapse' ? 'expand' : 'collapse'
  }

}

